export const ItemAssetLocationToThreeJSKeyMap: Record<string, string | string[]> = {
  'Base Color Texture': 'map',
  'Normal Texture': 'normalMap',
  'Metallic/Roughness Texture': [
    'metalnessMap',
    'roughnessMap'
  ],
  'Displacement Texture': 'displacementMap',
  'Ambient Occlusion Texture': 'aoMap'
};
